// Logging middleware
import constants from "../constants";

/* eslint-disable no-console */
const logger = store => next => action => {
  if (!store) return next(action);
  const result = next(action);

  if (
    process.env.NODE_ENV === "development" ||
    (typeof document !== "undefined" && document.cookie.match("lpDev"))
  ) {
    if (!action.type) {
      return console.info("thunk()");
    }
    console.groupCollapsed(`dispatching ${action.type}`);
    if (action.data || action.payload) console.info("data", action.data || action.payload);
    console.groupEnd();
  } else if (process.env.NODE_ENV === "production" &&
    typeof window !== "undefined" &&
    window.trackJs
  ) {
    if (action.type === constants.AJAX_ERROR) {
      window.trackJs.console.log(`${action.data.status} on ${action.data.url}`);
    } else {
      window.trackJs.console.log(action.type ? action.type : action.toString());
    }
  }

  // console.log("next state", store.getState());

  return result;
};
/* eslint-enable no-console */

export default logger;


// WEBPACK FOOTER //
// ./assets/shared/middleware/logger.js